module.exports = __webpack_public_path__ + "img/about-figures-header.jpg?599d5a2ce42aea0e92a96e3acdc67b8b";